(function () {
  'use strict';

  $(document).on('turbolinks:load', function () {
    var $setting = $('.kuroko-setting');
    if (!$setting.length) return;

    var $overlay = $('.kuroko-sheet-overlay');
    var $sheet = $overlay.find('.kuroko-sheet');

    // 1. 追加ボタン → シートを開く
    $setting.find('.kuroko-setting__add-btn').on('click', function () {
      $overlay.addClass('show');
      $('body').css('overflow', 'hidden');
      $sheet.find('.kuroko-sheet__checkbox').prop('checked', false);
      updateConfirmState();
    });

    // 2. シートを閉じる
    function closeSheet() {
      $overlay.removeClass('show');
      $('body').css('overflow', '');
    }
    $sheet.find('.js-kuroko-sheet-cancel, .kuroko-sheet__close').on('click', closeSheet);
    $overlay.on('click', function (e) {
      if (e.target === this) closeSheet();
    });
    $(document).on('keydown.kurokoSheet', function (e) {
      if (e.key === 'Escape' && $overlay.hasClass('show')) closeSheet();
    });

    // 3. チェックボックス → 確定ボタン活性化
    $sheet.on('change', '.kuroko-sheet__checkbox', updateConfirmState);
    $sheet.on('click', '.kuroko-sheet__item', function (e) {
      if (e.target.tagName.toLowerCase() === 'input') return;
      e.preventDefault();
      var $cb = $(this).find('.kuroko-sheet__checkbox');
      $cb.prop('checked', !$cb.prop('checked'));
      updateConfirmState();
    });

    function updateConfirmState() {
      var checked = $sheet.find('.kuroko-sheet__checkbox:checked').length;
      $sheet.find('.js-kuroko-sheet-confirm').prop('disabled', checked === 0);
    }

    // 4. 確定 → チップ追加 + hidden input追加 + シート閉じ
    $sheet.find('.js-kuroko-sheet-confirm').on('click', function () {
      var checked = $sheet.find('.kuroko-sheet__checkbox:checked').length;
      var total = $sheet.find('.kuroko-sheet__item').length;
      if (checked === total) {
        alert($setting.data('all-kuroko-error'));
        return;
      }
      $sheet.find('.kuroko-sheet__checkbox:checked').each(function () {
        var playerId = Number($(this).val());
        var playerName = $(this).siblings('.kuroko-sheet__name').text();
        addKurokoChip(playerId, playerName);
        $(this).closest('.kuroko-sheet__item').remove();
      });
      updateKurokoCount();
      closeSheet();
    });

    // 5. ×ボタン → チップ削除 + hidden input削除
    $(document).on('click', '.kuroko-setting__remove', function () {
      var $chip = $(this).closest('.kuroko-setting__chip');
      var playerId = $chip.data('player-id');
      var playerName = $chip.contents().filter(function () {
        return this.nodeType === 3;
      }).text().trim();
      $chip.remove();
      $setting.find('.kuroko-hidden-input[value="' + playerId + '"]').remove();
      restoreToSheet(playerId, playerName);
      updateKurokoCount();
    });

    function addKurokoChip(playerId, playerName) {
      var $chip = $('<span>', { class: 'kuroko-setting__chip', 'data-player-id': playerId });
      $chip.text(playerName);
      var $removeBtn = $('<button>', {
        class: 'kuroko-setting__remove',
        type: 'button',
        'aria-label': $setting.data('remove-aria-template').replace('%{name}', playerName)
      });
      $removeBtn.append($('<i>', { class: 'bx bx-x', 'aria-hidden': 'true' }));
      $chip.append($removeBtn);
      $setting.find('.kuroko-setting__chips').append($chip);
      $setting.append($('<input>', {
        type: 'hidden',
        class: 'kuroko-hidden-input',
        name: 'kuroko_player_ids[]',
        value: playerId
      }));
    }

    function restoreToSheet(playerId, playerName) {
      var $item = $('<label>', { class: 'kuroko-sheet__item' });
      var $cb = $('<input>', {
        type: 'checkbox',
        class: 'kuroko-sheet__checkbox visually-hidden',
        value: playerId
      });
      var $name = $('<span>', { class: 'kuroko-sheet__name' }).text(playerName);
      $item.append($cb, $name);
      $sheet.find('.kuroko-sheet__list').append($item);
    }

    function updateKurokoCount() {
      var count = $setting.find('.kuroko-setting__chip').length;
      var $countEl = $setting.find('.kuroko-setting__count');
      $countEl.text(count > 0 ? window.Janreco.pluralize($setting.data('count-template'), count) : '');
    }
  });
})();
